var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 5.79086 2.79086 4 5 4H37C39.2091 4 41 5.79086 41 8V40C41 42.2091 39.2091 44 37 44H35.5657H5C2.79086 44 1 42.2091 1 40V8Z",
    fill: "white",
    stroke: "#11CA73",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 1.33334C33.7678 1.33334 30.3334 4.76772 30.3334 9C30.3334 13.2323 33.7678 16.6667 38 16.6667C42.2323 16.6667 45.6667 13.2323 45.6667 9C45.6667 4.76772 42.2323 1.33334 38 1.33334Z",
    fill: "#F25252",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6666 9.66667H35.3333C34.9666 9.66667 34.6666 9.36667 34.6666 9C34.6666 8.63334 34.9666 8.33334 35.3333 8.33334H40.6666C41.0333 8.33334 41.3333 8.63334 41.3333 9C41.3333 9.36667 41.0333 9.66667 40.6666 9.66667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.175 20.175L23.15 16.15C22.8417 15.8417 22.4167 15.6667 21.975 15.6667H16C15.0834 15.6667 14.3417 16.4167 14.3417 17.3333L14.3334 30.6667C14.3334 31.5833 15.075 32.3333 15.9917 32.3333H26C26.9167 32.3333 27.6667 31.5833 27.6667 30.6667V21.3583C27.6667 20.9167 27.4917 20.4917 27.175 20.175ZM23.3334 26.5H21.8334V29C21.8334 29.4583 21.4584 29.8333 21 29.8333C20.5417 29.8333 20.1667 29.4583 20.1667 29V26.5H18.675C18.3 26.5 18.1167 26.05 18.3834 25.7917L20.7167 23.4667C20.8834 23.3083 21.1417 23.3083 21.3084 23.4667L23.6334 25.7917C23.8834 26.05 23.7 26.5 23.3334 26.5ZM21.8334 20.6667C21.8334 21.125 22.2084 21.5 22.6667 21.5H26.4167L21.8334 16.9167V20.6667Z",
    fill: "#11CA73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFile);
export default __webpack_public_path__ + "static/media/remove_file.93eede10c3496a2220819e9605de506b.svg";
export { ForwardRef as ReactComponent };